import Snippet from "../../../../components/Snippet/Snippet"
import {
    breakpointCol,
    breakpointColSm,
    breakpointLg,
    breakpointMd,
    breakpointXl
} from '../../../../assets/code-snippets/column/snip'

const ColumnBreakpoints = () => {
    return <div className="container fluid my-1" id="breakpoints">

        <div className="container fluid">
            <p className="text xl"><a href="#breakpoints" className="link">&#128279;</a> Responsive columns -
            breakpoints </p>
            <p className="text lg">Responsive column with pre-defined width</p>
        </div>

        <div className="container fluid shadow-md p-2 my-5">
            <p className="text md">There are several classes which can create responsive columns based on <span
                className="bold">browser's window width</span>, such as: </p>

            <div className="container xl">

                <div className="table" padding="2" cell-spacing="3" cell-border="1" table-striped="true">
                    <table>
                        <thead>
                            <tr>
                                <th>Tag Element</th>
                                <th>Additional Class</th>
                                <th>Description</th>
                                <th>Responsiveness</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code>div.col</code></td>
                                <td><code>.auto, .I, .II, .III, .IV, .V, .VI</code>
                                </td>
                                <td>Sets a specific width for each column</td>
                                <td>No</td>
                            </tr>
                            <tr>
                                <td><code>div.col</code></td>
                                <td><code>.sm, .sm-auto, .sm-I, .sm-II, .sm-III, .sm-IV, .sm-V, .sm-VI</code>
                                </td>
                                <td><code>sm-</code> breaks all columns at 576px</td>
                                <td>Yes</td>
                            </tr>
                            <tr>
                                <td><code>div.col</code></td>
                                <td><code>.md, .md-auto, .md-I, .md-II, .md-III, .md-IV, .md-V, .md-VI</code>
                                </td>
                                <td><code>md-</code> breaks all columns at 768px</td>
                                <td>Yes</td>
                            </tr>
                            <tr>
                                <td><code>div.col</code></td>
                                <td><code>.lg, .lg-auto, .lg-I, .lg-II, .lg-III, .lg-IV, .lg-V, .lg-VI</code>
                                </td>
                                <td><code>lg-</code> breaks all columns at 992px</td>
                                <td>Yes</td>
                            </tr>
                            <tr>
                                <td><code>div.col</code></td>
                                <td><code>.xl, .xl-auto, .xl-I, .xl-II, .xl-III, .xl-IV, .xl-V, .xl-VI</code>
                                </td>
                                <td><code>xl-</code> breaks all columns at 1200px</td>
                                <td>Yes</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <div className="container fluid my-8 shadow-sm p-1">
                <p className="text md bold info center">I, II, III, IV, V & VI</p>

                <div className="container md my-2">
                    <Snippet code={breakpointCol} language='html' />
                </div>

                <div className="row">
                    <div className="col I border-dark py-2 text-center">1 of 6</div>
                    <div className="col I border-dark py-2 text-center">2 of 6</div>
                    <div className="col I border-dark py-2 text-center">3 of 6</div>
                    <div className="col I border-dark py-2 text-center">4 of 6</div>
                    <div className="col I border-dark py-2 text-center">5 of 6</div>
                    <div className="col I border-dark py-2 text-center">6 of 6</div>
                </div>

            </div>

            <div className="container fluid my-8 shadow-sm p-1">
                <p className="text md bold info center">sm-I, sm-II, sm-III, sm-IV, sm-V, sm-VI</p>

                <div className="container md my-2">
                    <Snippet code={breakpointColSm} language='html' />
                </div>

                <div className="row">
                    <div className="col sm-I border-dark py-2 text-center">1 of 6</div>
                    <div className="col sm-I border-dark py-2 text-center">2 of 6</div>
                    <div className="col sm-I border-dark py-2 text-center">3 of 6</div>
                    <div className="col sm-I border-dark py-2 text-center">4 of 6</div>
                    <div className="col sm-I border-dark py-2 text-center">5 of 6</div>
                    <div className="col sm-I border-dark py-2 text-center">6 of 6</div>
                </div>

            </div>

            <div className="container fluid my-8 shadow-sm p-1">
                <p className="text md bold info center">md-I, md-II, md-III, md-IV, md-V, md-VI</p>

                <div className="container md my-2">
                    <Snippet code={breakpointMd} language='html' />
                </div>

                <div className="row">
                    <div className="col md-I border-dark py-2 text-center">1 of 6</div>
                    <div className="col md-I border-dark py-2 text-center">2 of 6</div>
                    <div className="col md-I border-dark py-2 text-center">3 of 6</div>
                    <div className="col md-I border-dark py-2 text-center">4 of 6</div>
                    <div className="col md-I border-dark py-2 text-center">5 of 6</div>
                    <div className="col md-I border-dark py-2 text-center">6 of 6</div>
                </div>

            </div>

            <div className="container fluid my-8 shadow-sm p-1">
                <p className="text md bold info center">lg-I, lg-II, lg-III, lg-IV, lg-V, lg-VI</p>

                <div className="container md my-2">
                    <Snippet code={breakpointLg} language='html' />
                </div>

                <div className="row">
                    <div className="col lg-I border-dark py-2 text-center">1 of 6</div>
                    <div className="col lg-I border-dark py-2 text-center">2 of 6</div>
                    <div className="col lg-I border-dark py-2 text-center">3 of 6</div>
                    <div className="col lg-I border-dark py-2 text-center">4 of 6</div>
                    <div className="col lg-I border-dark py-2 text-center">5 of 6</div>
                    <div className="col lg-I border-dark py-2 text-center">6 of 6</div>
                </div>

            </div>

            <div className="container fluid my-8 shadow-sm p-1">
                <p className="text md bold info center">xl-I, xl-II, xl-III, xl-IV, xl-V, xl-VI</p>

                <div className="container md my-2">
                    <Snippet code={breakpointXl} language='html' />
                </div>

                <div className="row">
                    <div className="col xl-I border-dark py-2 text-center">1 of 6</div>
                    <div className="col xl-I border-dark py-2 text-center">2 of 6</div>
                    <div className="col xl-I border-dark py-2 text-center">3 of 6</div>
                    <div className="col xl-I border-dark py-2 text-center">4 of 6</div>
                    <div className="col xl-I border-dark py-2 text-center">5 of 6</div>
                    <div className="col xl-I border-dark py-2 text-center">6 of 6</div>
                </div>

            </div>

        </div>
    </div>
}
export default ColumnBreakpoints